import { render, staticRenderFns } from "./VungleIcon.vue?vue&type=template&id=1e37406b&"
import script from "./VungleIcon.vue?vue&type=script&lang=js&"
export * from "./VungleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports